<template>
	<div location question :id="`question-${questionData.number}`">
		<questionheader :questionData="questionData" />
		<div data-question-main>
			<label :for="`question-${questionData.number}_answer-0`">{{get.textResource(`rs_location`)}}</label>
			<div data-answer>
				<div data-answer-container>
					<input 
						:id="`question-${questionData.number}_answer-0`"
						:disabled="outerFieldIsChecked"
						type="text" 	
						v-model="inputAddress"
						@blur="search()"
					/>
					<answerdescription v-if="questionData.answers[0].description !== ``" :answerData="questionData.answers[0]" :questionData="questionData" />
				</div>
			</div>
			<div search-error
				aria-live="assertive"
				v-if="searchHasFailed">
				<p error-message>{{$store.getters.textResource(`rs_location_not_found`)}}</p>
			</div>
			<l-map 
				ref="myMap" 
				:style="mapIsLoaded === true ? `height: 500px;width:100%;display: block;` : `height: 500px; width:100%; display: none;`"
				:zoom="mapSettings.zoom" 
				:center="mapSettings.center"
				@click="onMapClick($event)"
			>
				<l-tile-layer 
					:url="mapSettings.url" 
					:attribution="mapSettings.attribution"
				/>
				<v-locatecontrol 
					:options="{position: `topright`}"
				/>
				<font-awesome-icon  
					:icon="`map-marker`" 
				/>
				<l-marker 
					v-if="mapSettings.markerLatLng.length > 0"
					:lat-lng="mapSettings.markerLatLng" 
					:draggable="true" 
					@mouseup="onMapClick($event)"
				/>
			</l-map>
			<checkboxradio
                v-if="outerField"
                :questionData="questionData"
                :outerfield="true"
                :answerData="outerField"
                :showLabel="true"
                :disabled="state.global.showLoader"
                type="checkbox"
                @element-click="outerFieldClicked"
            />
		</div>
		<questionfooter :questionData="questionData" />
		<validationpopup :questionValidation="questionValidation" />
	</div>
</template>

<script>
import mixins from "@/global/mixins";
import methods from "@/global/methods.js";

import Vue2LeafletLocatecontrol from 'vue2-leaflet-locatecontrol';

export default {
	name: `location-question`,
	mixins: [mixins.defaultQuestion],
	components: {
		"v-locatecontrol": Vue2LeafletLocatecontrol,
	},
	data(){
        return {
			mapSettings: {
				url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
				attribution:
					'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
				zoom: 15,
				center: [51.505, -0.159],
				markerLatLng: [],
			},		
			map: {},
			inputAddress: ``,
			detailedAddressObject: ``,
			shadowAddress: ``,
			searchHasFailed: false
        }
    },
	computed: {
		mapIsLoaded() {
			return Object.keys(this.map).length !== 0;
		},
        outerField() {
            return this.questionData.answers.find((answer) => answer.type === `OuterField`);
		},
        outerFieldIsChecked: function () {
            return this.questionData.answers[1] !== undefined && this.questionData.answers[1].isChecked;
		},
		answersGiven() {
            return this.questionData.answers.filter((answer) => answer.openField !== `` || answer.isChecked).length;
        },
	},
		methods: {
			search() {
			if(this.inputAddress === ``) return;

			methods.xhr({
				type: "GET",
                url: `https://nominatim.openstreetmap.org/search?addressdetails=1&q=${this.inputAddress}&format=jsonv2&limit=1`,
				callback: (response) => {

					if (response.responseText === "[]") {
						this.inputAddress = ``;
						this.map = {};
						this.searchHasFailed = true;
						this.questionData.answers[0].isChecked = false;
					}
					else {
						this.searchHasFailed = false;
                        let location = JSON.parse(response.responseText);

                        this.detailedAddressObject = location[0].address;

                        if (this.mapIsLoaded === false) {
                            this.$nextTick(() => {
                                this.map = this.$refs.myMap.mapObject;
                                this.mapSettings.center = [location[0].lat, location[0].lon]
                                this.mapSettings.markerLatLng = [location[0].lat, location[0].lon]
                                this.map.panTo([location[0].lat, location[0].lon]);

                                this.map.zoomControl.setPosition('topright');
                                // Needed for completely showing the map..
                                setTimeout(function () {
                                    window.dispatchEvent(new Event("resize"));
                                }, 200);
                            });
                        }
                        else {
                            this.mapSettings.center = [location[0].lat, location[0].lon]
                            this.mapSettings.markerLatLng = [location[0].lat, location[0].lon]
                            this.map.panTo([location[0].lat, location[0].lon]);
                        }

						this.updateLocationAnswer(location[0]);
					}

					this.$store.commit(`changeGlobal`, {
                        variableName: `showLoader`,
                        newValue: false,
                    });
				}
			});
			
		},
		onMapClick(e) {
			let coord = e.latlng;
			this.mapSettings.markerLatLng = [coord.lat , coord.lng];
			this.searchAddress();
		},
		searchAddress() {
			let coord = this.mapSettings.markerLatLng;

			methods.xhr({
				type: "GET",
                url: `https://nominatim.openstreetmap.org/reverse?lat=${coord[0]}&lon=${coord[1]}&format=jsonv2`,
                callback: (response) => {
					let locationAddress = JSON.parse(response.responseText);
					this.detailedAddressObject = locationAddress.address;

					this.$store.commit(`changeGlobal`, {
                        variableName: `showLoader`,
                        newValue: false,
                    });
					this.updateLocationAnswer(locationAddress);
				}
			});
		},
		updateLocationAnswer(locationAddress) {
            this.inputAddress = locationAddress.display_name;
            let AddressLatLong = {
                address: locationAddress.display_name,
                latitude: locationAddress.lat,
                longitude: locationAddress.lon,
			}

			let inputField = this.questionData.answers[0];
			inputField.openField = JSON.stringify(AddressLatLong);
			inputField.isChecked = true;
		},
		loadExistingAnswer() {
			var addressObject = JSON.parse(this.questionData.answers[0].openField);
			this.inputAddress = addressObject.address;
            this.search();
        },
        outerFieldClicked() {
			let inputField = this.questionData.answers[0];
			let outerField = this.questionData.answers[1];

			outerField.isChecked = !this.outerFieldIsChecked;

			if (!outerField.isChecked) {
				if (inputField.shadowValue !== undefined) {
					inputField.isChecked = true;
					this.inputAddress = this.shadowAddress;
					this.search();
				}
			} else if (outerField.isChecked) {
                inputField.isChecked = false;
				this.shadowAddress = this.inputAddress;
				inputField.openField = ``;
				this.inputAddress = ``;
				this.map = {};
				this.searchHasFailed = false;
			}
		},
	},
	mounted() {
		if (this.questionData.answers !== null) {
			if (this.questionData.answers[0].openField !== "") {
				this.loadExistingAnswer();
			} else {
				this.questionData.answers[0].isChecked = false;
			}
		} 
	},
};
</script>

<style scoped>
[data-answer] {
	align-items: flex-start;
	flex-direction: column;
}

[data-answer-container] {
	display: flex;
	align-items: center;
	width: 100%;
} 

</style>
<style>
.leaflet-control-locate.leaflet-bar.leaflet-control {
    position: absolute;
    right: 0px;
    top: 68px;
}
[data-icon="map-marker"] {
	pointer-events: none;
    z-index: 99999;
    position: absolute;
    top: 87px;
    right: 21px;
    font-size: 16px;
}
[search-error] {
    padding-left: 5px;

    [error-message] {
        color: red;
    }
}
</style>